import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ChangePasswordModalComponent } from 'src/app/shared/components/change-password-modal/change-password-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

import { ApiConstants } from 'src/app/constants/api-constants';
import * as moment from 'moment-timezone';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Subscription } from 'rxjs';
import { NotificationUFC } from '../notification';
import {
  DataService,
  ServicecallService,
  SharedService,
  ToggleSidebarService,
} from 'src/app/services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  selectedValue: any;
  headerList: any = [];
  userFullName: any = localStorage.getItem('userFullName')
    ? localStorage.getItem('userFullName')
    : '';
  isFullScreen: boolean = false;
  refreshTime: any = this._datePipe.transform(
    Date.now(),
    'EEEE, MMMM d, y, h:mm:ss a zzzz'
  );
  isSocketSound: boolean = true;
  isActive: boolean = false;
  isReconnecting: boolean = false;
  openNotificationBar: boolean = false;
  notificationList: any = [];
  timeZoneNames: string[];
  searchTerm: any = null;
  timeZone = new FormControl();
  clearDropDownSearch: boolean = false;
  convertedTime: any;
  isLiveStatus: boolean = false;
  token: any = ApiConstants.blobSasToken;
  isDeveloperLive: boolean = true;
  isDeveloperLiveShow: boolean = false;
  roleName: string;
  @Input() isShown!: boolean;
  @Output() goLive = new EventEmitter();
  @ViewChild('timezonepopup') timezonepopup = {} as TemplateRef<string>;

  private _profileImg: any;
  private _username: any = localStorage.getItem('username')
    ? localStorage.getItem('username')
    : null;
  private _subscription: Subscription;
  private _currentPage: any;
  private _isSettingActive: boolean = false;
  private _masterWebNotification: any;
  private _dialogRef: any;
  private _roleListSubscription: Subscription;
  private _getSiteListSubscription: Subscription;
  private _routerSubscription: Subscription;
  private _logoutSubscription: Subscription;
  private _tenantConfig: any;

  @HostListener('document:fullscreenchange', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    if (!document?.fullscreenElement) {
      this.isFullScreen = !this.isFullScreen;
    }
  }
  constructor(
    public _service: ServicecallService,
    private _router: Router,
    private _modalService: NgbModal,
    private _sharedData: SharedService,
    private _toggleButton: ToggleSidebarService,
    private _translate: TranslateService,
    private _dataSer: DataService,
    private _datePipe: DatePipe,
    private _dialog: MatDialog
  ) {
    this.timeZoneNames = moment.tz.names();
    dayjs.extend(utc);
  }

  ngOnInit(): void {
    // TODO document why this method 'ngOnInit' is empty
    this._tenantConfig = this._service.getConfiguration('tenantGenericConfig')
      ? this._service.getConfiguration('tenantGenericConfig')
      : null;
    this._profileImg = localStorage.getItem('userImg')
      ? JSON.parse(localStorage.getItem('userImg'))
      : null;
    if (!sessionStorage.getItem('siteId')) {
      sessionStorage.setItem('siteId', 'null');
    }
    this._findRefreshTime();
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteUpdated' || res.name === 'apiRefresh') {
        this._loadHeaderList('default');
      } else if (res.name === 'siteDeleted') {
        this._loadHeaderList(res.name);
      } else if (res.name === 'trackerSiteChanged') {
        this._findFromHeaderList();
      } else if (res.name === 'isActiveSocket') {
        this.isActive = res?.args?.length ? res?.args[0] : true;
      } else if (res.name === 'isReconnectingSocket') {
        this.isReconnecting = res?.args?.length ? res?.args[0] : true;
      } else if (res.name === 'updateRefreshTimer') {
        this.refreshTime = this._datePipe.transform(
          Date.now(),
          'EEEE, MMMM d, y, h:mm:ss a zzzz'
        );
      } else if (res.name === 'onDateRangeChange') {
        this._isDeveloperLiveStatus(res?.args?.length ? res?.args[0] : {});
      } else if (res.name === 'gobackLive') {
        this.isDeveloperLive = true;
      } else if (res.name === 'notificationOutsideClick') {
        this.openNotificationBar = res?.args[0];
      } else if (res.name === 'clearNotification') {
        this.notificationList = [];
      }
    });
    this._loadHeaderList('default');
    this._routerSubscription = this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (
          this._router.url.split('/')[1] &&
          this._router.url.split('/')[1] === 'settings'
        ) {
          this._isSettingActive = true;
        } else {
          this._isSettingActive = false;
        }
      }
      this.isLiveStatus =
        this._router.url?.split('/')?.[1] === 'home' ||
        this._router.url?.split('/')?.[1] === 'tracker' ||
        this._router.url?.split('/')?.[2] === 'profile'
          ? true
          : false;
      this.isDeveloperLiveShow =
        this._router.url?.split('/')?.[1] === 'developer' ? true : false;
    });
    if (
      this._router.url.split('/')[1] &&
      this._router.url.split('/')[1] === 'settings'
    ) {
      this._isSettingActive = true;
    } else {
      this._isSettingActive = false;
    }
    this.notificationList = JSON.parse(
      sessionStorage.getItem('masterNotificationList')
    );
    if (
      this._tenantConfig?.tenant === 'UFC' ||
      this._tenantConfig?.tenant === 'USV' ||
      this._tenantConfig?.tenant === 'CIC'
    ) {
      this.notificationList = NotificationUFC;
    }
    this.notificationList?.map(
      (item: any) =>
        (item.convertedTime = this._service.getLastSeenFormat(
          new Date(item.sourceTime)
        ))
    );
    this.isLiveStatus =
      this._router.url?.split('/')?.[1] === 'home' ||
      this._router.url?.split('/')?.[1] === 'tracker'
        ? true
        : false;
    this.isDeveloperLiveShow =
      this._router.url?.split('/')?.[1] === 'developer' ? true : false;
  }

  captureNotification() {
    this.openNotificationBar = !this.openNotificationBar;
    this._dataSer.broadcast('openNotification', this.openNotificationBar);
  }
  logout() {
    this._service.clearDateState('all');
    this._service.setVehicleDateRange(null);
    this._logoutSubscription = this._service
      .logout(this._username)
      .subscribe((res: any) => {
        if (res['status']) {
          if (res['response']) {
            this._service.toasterService({
              type: 'success',
              msg: res['response']['message'],
            });
            this._service.resetRbac();
            this.clearAllFilters();
            this._dataSer.broadcast('socketDisconnectedOnLogout');
            localStorage.clear();
            sessionStorage.clear();
            this._router.navigate(['login']);
          } else {
            this._service.toasterService({
              type: 'error',
              msg: res['response']['message'],
            });
          }
        } else {
          this._service.toasterService({
            type: 'error',
            msg: res['response']['message'],
          });
        }
      });
  }

  /**
   * Clears all saved filters on logout
   */
  clearAllFilters() {
    this._service.setFilters({}, 'entity');
    this._service.setSearchKey(null, 'entity');
    this._service.setAlertDtcFilters(false, 'isActiveAlerts');
    this._service.setAlertDtcFilters(false, 'isActiveDTCCases');
    this._service.setFilters(null, 'dtc');
    this._service.setFilters(null, 'dtcAnalyze');
    this._service.setSearchKey(null, 'dtc');
    this._service.setSearchKey(null, 'dtcAnalyze');
  }

  toggleSidenav() {
    if (this.isShown) {
      this._toggleButton.setToggleButtonClick('sub');
    } else {
      this._toggleButton.setToggleButtonClick('clicked');
    }
  }

  changePassword() {
    this._sharedData.send(true);
    const modalRef = this._modalService.open(ChangePasswordModalComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'PasswordModalClass',
    });
    modalRef.componentInstance.username = this._username;
    modalRef.componentInstance.message = null;
    modalRef.result.then(
      (result) => {
        this._sharedData.send(false);
      },
      (reason) => {}
    );
  }

  loadLaunch() {
    this._router.navigate(['/login']);
  }
  siteChange(event: any) {
    sessionStorage.setItem(
      'siteId',
      JSON.stringify(event.value ? event?.value._id : null)
    );
    sessionStorage.setItem(
      'selectedSiteProfile',
      JSON.stringify(event.value ? event?.value.name : null)
    );
    this._dataSer.broadcast('siteChanged', event.value);
    if (localStorage.getItem('domain') === 'IOC' && event?.value._id && this._router.url?.split('/')?.[1] === 'plants' && this._router.url?.split('/')?.[2] !== 'dispensing-units' && this._router.url?.split('/')?.[2] !== 'tanks') {
      this._router.navigate(['plants/profile', event?.value._id]);
    }
  }
  fullScreen() {
    if (!this.isFullScreen) {
      document.documentElement.requestFullscreen();
      this.isFullScreen = !this.isFullScreen;
    } else {
      document.exitFullscreen();
    }
  }
  setUrl() {
    this._currentPage = this._router.url.split('/')[2]
      ? this._router.url.split('/')[2]
      : null;
  }
  apiRefresh() {
    this._dataSer.broadcast('apiRefresh');
    this._findRefreshTime();
  }
  socketSoundSettings() {
    this.isSocketSound = !this.isSocketSound;
    this._dataSer.broadcast('socketSound', this.isSocketSound);
  }
  closeWebSocket() {
    sessionStorage.setItem('socketDisconnected', JSON.stringify(this.isActive));
    this._dataSer.broadcast('socketDisconnected', this.isActive);
  }
  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._roleListSubscription?.unsubscribe();
    this._getSiteListSubscription?.unsubscribe();
    this._routerSubscription?.unsubscribe();
    this._logoutSubscription?.unsubscribe();
  }

  timeZoneChanged(): void {
    this._dataSer.setTimeZone(this.timeZone.value);
    this.apiRefresh();
  }

  openTimeZoneModal() {
    this._dialogRef = this._dialog.open(this.timezonepopup, {
      width: '40%',
      panelClass: 'custom-modalbox',
    });
  }

  triggerEvent() {
    this.clearDropDownSearch = true;
    this.searchTerm = null;
  }
  goBackLive() {
    if (!this.isDeveloperLive) {
      this.goLive.emit('live');
      const { startDate, endDate } = {
        startDate: dayjs().subtract(1, 'hours'),
        endDate: dayjs(),
      };
      dayjs.extend(utc);
      const startDateUTC = startDate.utc();
      const endDateUTC = endDate.utc();
      this._dataSer.broadcast('gobackLive', {
        startDate: startDateUTC.toISOString(),
        endDate: endDateUTC.toISOString(),
      });
    }
  }

  getRole() {
    if (!sessionStorage.getItem('roleName')) {
      this._roleListSubscription = this._service
        .roleList()
        .subscribe((result: any) => {
          if (result['status'] && result?.['response']?.['data']?.length) {
            this.roleName = result?.['response']?.['data'].find(
              (elem: any) => elem?._id === localStorage.getItem('roleId')
            )?.roleName;
            sessionStorage.setItem('roleName', this.roleName);
          }
        });
    } else {
      this.roleName = sessionStorage.getItem('roleName');
    }
  }

  private _loadHeaderList(type?: any) {
    this._getSiteListSubscription = this._service
      .getSiteList()
      .subscribe((response: any) => {
        if (response['status']) {
          if (response['response']) {
            this._service.setSiteLsit([...response['response']['data']]);
            if (
              this._service.rbacManagement('home_SingleSite') ||
              this._service.rbacManagement('sites_SingleSite')
            ) {
              if (
                response['response']['data'] &&
                response['response']['data'].length
              ) {
                this.headerList = [...response['response']['data']];
                sessionStorage.setItem(
                  'siteId',
                  JSON.stringify(this.headerList[0]?._id)
                );
                this.selectedValue = this.headerList[0];
              } else {
                this.headerList = [];
              }
              this._dataSer.broadcast('singleSite');
            } else {
              this.headerList = [
                {
                  name: 'All ' + this._translate.instant('plants'),
                  _id: null,
                },
                ...response['response']['data'],
              ];
              if (type === 'siteDeleted') {
                sessionStorage.setItem('siteId', 'null');
                this.selectedValue = this.headerList[0];
              } else if (type === 'default') {
                this._findFromHeaderList();
                // this.selectedValue = value ? value: this.headerList[0];
              }
            }
          }
        } else {
          this.headerList = [];
        }
      });
  }

  private _findFromHeaderList() {
    const value = this.headerList.find(
      (item: any) =>
        item._id === JSON.parse(sessionStorage.getItem('siteId') || '{}')
    );
    if (value) {
      this.selectedValue = value;
    } else {
      sessionStorage.setItem('siteId', 'null');
      this.selectedValue = this.headerList[0];
    }
  }
  private _userProfileRedirect() {
    const url = this._router.url.split('/');
    const userId = url[2] ? url[2] : null;
    const id = localStorage.getItem('userId')
      ? localStorage.getItem('userId')
      : null;
    if (id && userId !== 'profile') {
      if (this.isShown) {
        this._toggleButton.setToggleButtonClick('sub');
      }
      this._router.navigate(['users/profile/' + id]);
    }
  }

  private _findRefreshTime() {
    const timeZoneName = sessionStorage.getItem('selectedTimeZone');
    if (timeZoneName) {
      this.timeZone.setValue(timeZoneName);
      const gmtOffsetString = this._dataSer.findgmtOffset(timeZoneName);
      this.refreshTime = this._datePipe.transform(
        Date.now(),
        'EEEE, MMMM d, y, h:mm:ss a zzzz',
        gmtOffsetString
      );
    } else {
      this.refreshTime = this._datePipe.transform(
        Date.now(),
        'EEEE, MMMM d, y, h:mm:ss a zzzz'
      );
      const localTime = moment.tz.guess();
      this.timeZone.setValue(localTime);
    }
  }

  reconnectSocket() {
    this._dataSer.broadcast('socketReconnect');
  }
  private _isDeveloperLiveStatus(range: any) {
    if (range?.label === 'Yesterday' || range?.label === 'Last Month') {
      this.isDeveloperLive = false;
    } else {
      this.isDeveloperLive = true;
    }
  }
}
